import mixin from "../../mixins/getNestedProperty.js";

function addCommonSettings(currentSettings, channelValues, channelOptions) {
    if (currentSettings[0].groupingName == 'Settings') {
        var commonSettings = [
            {
                name : "parents_also_enable_children",
                label : "Enable/Disable all children on this channel when parent is enabled/disabled",
                required : false,
                type : "select",
                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                value : (mixin.methods.getNestedProperty(channelValues, 'json_options', 'configuration', 'parents_also_enable_children')) ? 'true'  : 'false',
                options : [
                    {
                        'id' : 'false',
                        'name' : 'Disabled - Each child must be individually enabled/disabled'
                    },
                    {
                        'id' : 'true',
                        'name' : 'Enabled - All children will be enabled/disabled alongside their parents'
                    },
                ],
                tooltip: 'By default you have to enable/disable each child product into this channel individually, even if the parent is enabled. This settings changes that and the children will follow the parent channel status automatically.',
                tooltip_position: 'top'
            }
        ];
    
        let newSettings = currentSettings;

        newSettings[0].groupItems = [...newSettings[0].groupItems, ...commonSettings];

        return newSettings;
    }

    return currentSettings;
}

function returnRelationsWithRelationAttributesGroupItem(channelValues) {
    return {
        name : "relations_with_relation_attributes",
        label : "Relations with Relation Attributes",
        required : false,
        type : "checkbox",
        column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
        value : (mixin.methods.getNestedProperty(channelValues, 'json_options', 'metafields', 'relations_with_relation_attributes')) ? true  : '',
        tooltip: '',
        tooltip_position: 'top'
    };
}

export default {
    methods: {
        'addCommonSettings': addCommonSettings,
        'returnRelationsWithRelationAttributesGroupItem': returnRelationsWithRelationAttributesGroupItem
    }
};